import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import CustomerType from '../../common/customer_type';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { IconButton, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import '../../assign-prescriptions/index.css';
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import getPatientTypeNameByType from '../../common/getPatientTypeNameByType';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {
      order,
      orderBy,
      sortId,
      className,
      t
    } = this.props;
    const rows = [
      { id: "first_name", numeric: false, disablePadding: false, label: t("Report.Patient.FirstName"), padding: '10px', field: 'first_name' },
      { id: "last_name", numeric: false, disablePadding: false, label: t("Report.Patient.LastName"), padding: '10px', field: 'last_name' },
      { id: "member_id", numeric: false, disablePadding: false, label: t("Report.Patient.MemberID"), padding: '10px', field: 'member_id' },
      { id: "drivers_license_no", numeric: false, disablePadding: false, label: t("Report.Patient.DriverLicenceNo"), padding: '10px', field: 'drivers_license_no' },
      { id: "dob", numeric: false, disablePadding: false, label: t("Report.Patient.DOB"), padding: '10px', field: 'dob_str' },
      { id: "email", numeric: false, disablePadding: false, label: t("Report.Patient.Email"), padding: '10px', field: 'email' },
      { id: "phone", numeric: false, disablePadding: false, label: t("Report.Patient.Phone"), padding: '10px', field: 'phone' },
      { id: "name", numeric: false, disablePadding: false, label: t("Report.Patient.Source"), padding: '10px', field: 'name' },
      { id: "enroll_date", numeric: false, disablePadding: false, label: t("Report.Patient.EnrollDateTime"), padding: '10px', field: 'created_on' },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map((row, props) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding }}
                className={className.tableCell}
              >
                {['drivers_license_no'].includes(row.id) ?
                  (<TableSortLabel style={{ cursor: 'text' }} className={className.tableCell}>
                    {row.label}
                  </TableSortLabel>
                  ) : (
                    <Tooltip
                      title={t("Global.Label.Filter.Sort")}
                      placement={row.numeric ? "bottom-end" : "bottom-start"}
                      enterDelay={300}
                      className={className.tableCell}
                    >
                      <TableSortLabel
                        active={orderBy === row.field && sortId === row.id}
                        direction={order}
                        onClick={this.createSortHandler(row.id, row.field)}
                        className={className.tableCell}
                      >
                        {row.label}
                      </TableSortLabel>
                    </Tooltip>
                  )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)


const styles = theme => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  }
  ,
  padding10px: {
    padding: '10px',
    fontSize: '0.75rem'
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  },
  tableCell: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    fontWeight: '4500'
  },
});

let FilterObj = {
  searchtext: '',
  CustomerType: CustomerType.Kiosk_Customer,
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
  group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      loader: false,
      isDataEmpty: true,
      totalRecords: 0,
      isButtonDisabled: false,
      queryId: "",
      groups: [],
    };
    this.debouceTimeout = null;
  }

  componentDidMount() {
    FilterObj.group_id = sessionStorage.getItem("groupID")
    this.fetchSuggestions();
    this.BindGrid();
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }
  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/EnrolledPatientReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(FilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      }).then((csvData) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        this.setState({ loader: false });
        let csvRow = [];
        let Array = [['Id', 'FirstName', 'LastName', 'Drivers License No', 'DOB', 'Email', 'Phone', 'Source', 'Enroll Date/Time']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              if (i.dob_str) {
                i.dob_str = currentUserLang === 'en' ? moment(i.dob_str).format('MM/DD/YYYY') : moment(i.dob_str).format('DD/MM/YYYY')
              } else {
                i.dob_str = '';
              }
              Array.push(
                [
                  i.first_name,
                  i.last_name,
                  i.member_id,
                  i.drivers_license_no,
                  i.dob_str,
                  i.email,
                  i.phone,
                  i.name,
                  i.enroll_date ? this.convertToTimeZone(i && i.enroll_date) : ''
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "EnrolledPatientsReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      });
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['first_name', 'last_name', 'member_id', 'drivers_license_no', 'enroll_date', 'dob'].includes(field)) {
      tablename = 'customers';
    }
    if (['email', 'phone'].includes(field)) {
      tablename = 'contacts';
    }
    if (['name'].includes(field)) {
      tablename = 'customer_type';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    FilterObj.sortOrder = order;
    FilterObj.sortColumn = field;
    FilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    FilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    const { data } = this.state;
    FilterObj.pageNo = 0;
    FilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };
  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    FilterObj.pageNo = 0;
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    FilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }

  BindGrid = () => {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + 'getkioskcustomer', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(FilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(uData => {
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({ data: uData.results, totalRecords: uData && uData.total });
          setTimeout(() => {
            this.setState({ loader: uData && uData.total && false, isDataEmpty: false, isButtonDisabled: false });
          }, 5000)
        }
        else {
          this.setState({ data: null, loader: false, isDataEmpty: true, isButtonDisabled: true });
        }
      });
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    FilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const { classes, t } = this.props;
    const { data, totalRecords, queryId, groups } = this.state;
    const currentUserLang = localStorage.getItem('i18nextLng');
    return (
      <Paper className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <div>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <TableBody>
              <TableRow>
                <TableCell style={{ width: "30%", borderBottom: "none" }}>
                  <TextField id="idsearchtxt"
                    defaultValue=""
                    value={this.state.searchtxt}
                    label={t("Report.Patient.Search")}
                    onChange={this.onSearchChange}
                    fullWidth
                    inputProps={{
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                    variant="standard"
                  />
                </TableCell>
                <TableCell style={{ width: "30%", borderBottom: "none" }}>
                  <FormControl
                    variant='standard'
                    sx={{ m: '16px 0', minWidth: 347 }}
                  >
                    <InputLabel id='preferred-group-label'>
                      {t('Group.User.GroupControlTitle')}
                    </InputLabel>
                    <Select
                      labelId='preferred-group-label'
                      id='preferred-group-select-standard'
                      value={queryId}
                      onChange={this.handleInputChange}
                      variant='standard'
                      label={t('Group.User.GroupControlTitle')}
                    >
                      {groups.length > 0 &&
                        groups.map((type, index) => (
                          <MenuItem
                            key={index}
                            value={type.id}
                            className={classes.locationType}
                          >
                            {type.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell style={{ width: "20%", borderBottom: "none" }}>
                </TableCell>
                <TableCell style={{ width: "25%", borderBottom: "none", textAlign: "right" }}>
                  <Tooltip key="single-edit" title={t("Report.Patient.ExportCSVTooltip")}>
                    <IconButton
                      style={{ marginRight: '0' }}
                      aria-label="ExportCSV"
                      disabled={this.state.isButtonDisabled}
                    >
                      <img alt="download" onClick={() => { this.exportCSV() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <Divider style={{ marginTop: '10px', height: '5px', borderColor: 'rgba(0, 0, 0, 0.12)', borderBottomWidth: '5px', borderStyle: 'solid' }} />
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={FilterObj.sortOrder}
              orderBy={FilterObj.sortColumn}
              sortId={this.state.sortId}
              onRequestSort={this.handleRequestSort}
              className={classes}
            />
            <TableBody>
              {!data ?
                (<TableRow>
                  <TableCell colSpan={12} style={{ textAlign: "center", padding: '10px 0px' }}>
                    {this.state.isDataEmpty && t("Report.Patient.NoDataFound")}
                  </TableCell>
                </TableRow>)
                :
                data && data.length > 0 &&
                stableSort(data, getSorting(FilterObj.sortOrder, FilterObj.sortColumn))
                  .map(n => {
                    if (n.dob_str != null) {
                      n.dob_str = currentUserLang === 'en' ? moment(n.dob_str).format('MM/DD/YYYY') : moment(n.dob_str).format('DD/MM/YYYY')
                    } else {
                      n.dob_str = '';
                    }
                    console.log(n.name)
                    return (
                      <TableRow sx={{ height: '50px' }}>
                        <TableCell className={classes.padding10px}>{n.first_name}</TableCell>
                        <TableCell className={classes.padding10px}>{n.last_name}</TableCell>
                        <TableCell className={classes.padding10px}>{n.member_id}</TableCell>
                        <TableCell className={classes.padding10px}>{n.drivers_license_no}</TableCell>
                        <TableCell className={classes.padding10px}>{n.dob_str}</TableCell>
                        <TableCell className={classes.padding10px}>{n.email}</TableCell>
                        <TableCell className={classes.padding10px}>{n.phone}</TableCell>
                        <TableCell className={classes.padding10px}>{getPatientTypeNameByType(n.name, t)}</TableCell>
                        <TableCell className={classes.padding10px}>{n.enroll_date ? this.convertToTimeZone(n && n.enroll_date) : ''}</TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            component="div"
            count={totalRecords || 0}
            rowsPerPage={FilterObj.pageSize}
            page={FilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </Paper>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/enrolled-patients/index.js